import React, { useEffect, useState } from "react";
import swal from "@sweetalert/with-react";
import Swal from "sweetalert2";
import moment from "moment";
import { Link } from "react-router-dom";
import Responseloader from "../../ShortCutComponents/ResponseLoader";
import { GetIp } from "../../ShortCutComponents/Get_ip";
import "./myReactSelect.css";
import { Button } from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "./formsTable.css";
import "./baseForms.css";
import axios from "axios";
import { baseurl } from "../../../../baseurl";
import { checkPermission } from "../../../../Helper";
import { amButtonLabels } from "../../ShortFunction/shortFunctions";
import PosSaleOrder from "./posSaleOrder"

let companyId = localStorage.getItem("companyId");
let username = localStorage.getItem("username");
var token = localStorage.getItem("token");


export default function PartyOverview(props) {
  const [table, setTable] = useState({
    OverViewDataTable: [],
  });
  const [loadingResponse, setLoadingResponse] = useState(false);
  const [showItemModal, setShowItemModal] = useState(false);
  const [dataId, setDataId] = useState(null);

  useEffect(() => {
    const funCall = async (value) => {
      await asyncRollCheck(value);
    };
    funCall(0);
    getData();
  }, []);
  const asyncRollCheck = async (value) => {
    let pathname = "/posSaleOrderMaster";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };

  const getData = () => {
    // var offSet, pageSize;
    setLoadingResponse(true);

    axios
      .post(
        `${baseurl}/subsistence/getPosSaleOrderMaster`,
        {
          companyId: companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        setLoadingResponse(false);
        setTable({
          OverViewDataTable: res.data.data,
        });
      })
      .catch((err) => {
        console.log(err);
        setLoadingResponse(false);
        swal({
          title: "Error",
          text: "Something went wrong, try to refresh the page and try again.",
          icon: "error",
        });
      });
  };
  const redirectToForm = (row) => {
    // props.history.push({
    //   pathname: "/posSaleOrder",
    //   state: { 
    //     id: row?.INVOICE_ID, 
    //   },
    // });

    setDataId(row?.INVOICE_ID);
    setShowItemModal(!showItemModal);
  };
  const getUserIp = async function () {
    let res = await GetIp();
    console.log(res);
    return {
      userIp: res.ip,
      userCountry: res.country,
    };
  };
  const blocked = () => {
    swal({
      title: "This Module is not in Use",
      text: "operation should not be performed!",
      icon: "warning",
    });
  };



  const amAuth = (row) => {
    setLoadingResponse(true);
    if (row.am_status === 2 || row.am_status === 5) {
      const resultRemoveData = axios.post(
        `${baseurl}/Authorizer/checkAndDeleteDoc`,
        {
          companyId: companyId,
          // date: row.bill_date,
          date: moment().format("YYYY-MM-DD"),
          id: row.INVOICE_ID,
          book_id: row.INV_BOOK_ID, //saif
          sub_inv_id: row.sub_inv_id, //saif
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      );
      resultRemoveData
        .then(function (res) {
          const data = res.data.data?.count_of_marked_records;
          // console.log("hellll", data);
          swal({
            title: "Successfully Revoked!",
            text: "Revoked",
            icon: "success",
            timer: 2000,
            showConfirmButton: false,
          });
        })
        .catch(function (error) {
          if (error.response) {
            // backend sent a response with an error code

            // console.log(error.response.data); // full backend error object
            swal({
              title: "Error!",
              text: error.response.data.message,
              icon: "error",
              timer: 3000,
              showConfirmButton: false,
            });
          } else {
            // network or other error
            console.log("Error:", error.message);
          }
        })
        .finally(() => {
          setLoadingResponse(false);
          getData()

          // thisContex.refreshData();
        });
    } else {
      axios
        .post(
          `${baseurl}/Authorizer/am_SendForAuth`,
          {
            companyId: companyId,
            // date: row.bill_date,
            date: moment().format("YYYY-MM-DD"),
            id: row.INVOICE_ID,
            book_id: row.INV_BOOK_ID, //saif
            sub_inv_id: row.sub_inv_id, //saif
            username: username,
          },
          {
            headers: {
              authorization: token,
            },
          }
        )

        .then(function (res) {
          setLoadingResponse(false);
          const data = res.data.data;
          console.log("hellll", res, data);
          if (data) {
            swal({
              title: "Saved Successfully!",
              text: "Added",
              icon: "success",
            }).then(() => {
              getData()
            });
          } else {
            swal({
              title: "Send for App",
              text: "this doc is not submitted!.",
              icon: "warning",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch(function (error) {
          setLoadingResponse(false);
          console.log(error);
        });
    }
  }

  function statusFormatter(cell, row) {
    let element = row;
    console.log(element);
    let button = row.am_status;
    let buttonName, buttonTooltip, buttonDisable, iconName, iconTitle;
    if (button) {
      let buttonInfo = amButtonLabels(button);
      buttonName = buttonInfo.buttonName;
      buttonTooltip = buttonInfo.tooltip;
      buttonDisable = buttonInfo.disable;
      iconName = buttonInfo.iconName;
      iconTitle = buttonInfo.iconTitle;
    }

    return (
      <div>
        {button ? (
          <>
            <span>
              <img
                src={iconName}
                alt="Processing"
                title={iconTitle}
                style={{ width: "20px", height: "20px", marginRight: "8px" }}
              />
            </span>
            <span>
              <Button
                className="mr-1"
                size="sm"
                title={buttonTooltip}
                color="success"
                onClick={() => amAuth(row)}
                disabled={buttonDisable}
              >
                {buttonName}
              </Button>
            </span>
          </>
        ) : null}

        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            // color="primary"
            onClick={() => redirectToForm(row, 1)}
          >
            <i className="fa fa-eye"></i>
          </Button>
        </span>
      </div>
    );
  }

  function orderDetHandler(cell, row) {
    return (
      <div>
        <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            // color="primary"
            onClick={() => redirectToForm(row, 1)}
          >
            <i className="fa fa-eye"></i>
          </Button>
        </span>

        {/* <span>
          <Button
            style={{ margin: "3px" }}
            type="submit"
            size="sm"
            color="success"
            onClick={() => redirectToForm(row, 2)}
            // onClick={blocked}
          >
            Edit
          </Button>
        </span> */}

      </div>
    );
  }
  const options = {
    paginationShowsTotal: true,
    page: 1,
    sizePerPage: 15,
    pageStartIndex: 1,
    paginationSize: 5,
    prePage: "Prev",
    nextPage: "Next",
    firstPage: "First",
    lastPage: "Last",
    prePageTitle: "Go to previous",
    nextPageTitle: "Go to next",
    firstPageTitle: "Go to first",
    lastPageTitle: "Go to Last",
    paginationPosition: "top",
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "30",
        value: 30,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "100",
        value: 100,
      },
      {
        text: "All",
        value: table.OverViewDataTable?.length,
      },
    ],
  };
  return (
    <>
      {loadingResponse ? (
        <Responseloader />
      ) : (
        <div className="container-fluid bg-white">
          <div className="row">
            <div className="col-md-4 h3 p-3">POS Sale Order</div>
            {/* <div className="col-md-4 h3 p-3" style={{ color: "red" }}>
              
            </div>
            <div className="col-md-4 d-flex flex-row-reverse mt-3">
              <Link
                to={"/DepartmentPlanSetup"}
                class="btn btn-outline-success rounded-pill mx-2 mb-3"
              >
                <i class="fa fa-plus pr-2" aria-hidden="true"></i>
                New Department Plan Setup
              </Link>
               
            </div> */}
          </div>

          <div translate="no" className="">
            <BootstrapTable
              data={table.OverViewDataTable}
              striped
              pagination
              hover
              search
              tableHeaderClass="rpr_header"
              tableBodyClass="rpr_body"
              containerClass="rpr_container"
              options={options}
            >
              <TableHeaderColumn
                dataField="DOCUMENT_NO"
                dataAlign="center"
                width="10%"
                dataSort={true}
                isKey={true}
              >
                Doc.no
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="formated_date"
                dataAlign="center"
                width="20%"
                dataSort={true}
              >
                Date
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="customerName"
                dataAlign="center"
                width="50%"
                dataSort={true}
              >
                Customer
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField="INVOICE_ID"
                dataAlign="center"
                width="20%"
                dataSort={true}
                dataFormat={statusFormatter}
              >
                Status
              </TableHeaderColumn>
              {/* <TableHeaderColumn
                dataAlign="center"
                dataField="INVOICE_ID"
                width="15%"
                dataFormat={orderDetHandler}
                className="rpr_header"
              >
                Action
              </TableHeaderColumn> */}
            </BootstrapTable>
          </div>

          {showItemModal && (
            <PosSaleOrder
              id={dataId}
              callback={() => setShowItemModal(!showItemModal)}
            />
          )}
        </div>


      )}
    </>
  );
}
